import { render, staticRenderFns } from "./FooterLinksForMates.vue?vue&type=template&id=10553b15"
import script from "./FooterLinksForMates.vue?vue&type=script&lang=js"
export * from "./FooterLinksForMates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports